import { GeneralDecoration } from "../office-elements/general-decoration.js";
import { buildModelUrl } from "../office/office.service.js";
import { useOffice } from "../office/use-office.js";
import { OfficeLogo } from "./office-logo.js";

export const DynamicDecorationRenderer = () => {
  const { preset, logoUrl } = useOffice();

  return (
    <>
      {preset.manifest.decorations
        ?.map((item, index) => {
          const key = `decoration-${index}`;
          const commonProps = {
            castShadow: true,
            modelPath: item.model
              ? buildModelUrl(preset.modelsDirectory, item.model)
              : "",
            receiveShadow: true,
          };

          switch (item.type) {
            case "SmallTableNoLogic":
            case "Plant01":
            case "Plant02": {
              return <GeneralDecoration key={key} {...commonProps} {...item} />;
            }

            default: {
              console.warn(`Unknown decoration type: ${item.type}`);
              return null;
            }
          }
        })
        .filter(Boolean)}

      <OfficeLogo config={preset.manifest.logo} customLogoUrl={logoUrl} />
    </>
  );
};
